import {ReactNode} from 'react'
import {Button, ButtonProps} from 'react-bootstrap'

interface FormResetBtnProps extends ButtonProps {
  children?: ReactNode
}
function FormResetBtn({children, ...rest}: FormResetBtnProps) {
  return (
    <Button type="reset" variant="secondary" {...rest}>
      {children || 'Reset'}
    </Button>
  )
}

export default FormResetBtn
